import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import featureSettingsMutations from './featureSettingsMutations'
import experimentActions from './experimentActions'
import userActions from './userActions'
import {RunStates} from './runStates'
import { initializeFirebase } from './firebaseModule'
import defaultSettings from './defaultSettings'
Vue.use(Vuex)

// const debug = process.env.NODE_ENV !== 'production'

const store = new Vuex.Store({
  state: {
    /* saving an experiment saves the experiment input and name */
    /* loading an experiment reruns the experiment */
    /* experiment input */
    classes: [],
    testText: null,
    featureSettings: defaultSettings.getDefaultFeatureSettings(),
    removedFeatures: defaultSettings.getDefaultRemovedFeatures(),
    chunking: defaultSettings.getDefaultChunking(),

    experimentName: null,

    /* experiment status and output */
    featuresState: RunStates.NOT_RUN,
    updateFeaturesState: RunStates.NOT_RUN,
    features: {},
    cvState: RunStates.NOT_RUN,
    crossValidationResults: {},
    classifyState: RunStates.NOT_RUN,
    testTextResults: [],

    experimentSaved: false,

    /* login */
    isLoggedIn: false,
    username: null,
    loginInProgress: false,

    /* user data */
    favorites: [],
    recent: [],
    savedExperiments: []
  },
  mutations: {
    ...mutations,
    ...featureSettingsMutations
  },
  actions: {
    ...experimentActions,
    ...userActions
  },
  strict: !(process.env.NETLIFY) // debug
})

initializeFirebase(store)

export default store



// WEBPACK FOOTER //
// ./src/store/index.js